import { render, staticRenderFns } from "./RegisterDriverComplete.vue?vue&type=template&id=2c50c302&scoped=true&lang=pug&"
import script from "./RegisterDriverComplete.vue?vue&type=script&lang=ts&"
export * from "./RegisterDriverComplete.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterDriverComplete.vue?vue&type=style&index=0&id=2c50c302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c50c302",
  null
  
)

export default component.exports